import { Reveal, SectionLabel } from "./Reveal";
import { ASSETS, COUNTRIES, EQUIPMENT } from "../data/content";

export const GlobalReach = () => (
  <section
    data-testid="global-reach-section"
    className="relative overflow-hidden bg-[#0A192F] py-24 lg:py-32"
  >
    <img
      src={ASSETS.worldMap}
      alt="World map"
      className="absolute inset-0 h-full w-full object-cover opacity-[0.14]"
    />
    <div className="absolute inset-0 bg-gradient-to-b from-[#0A192F] via-[#0A192F]/85 to-[#0A192F]" />

    <div className="relative mx-auto max-w-[1400px] px-5 lg:px-10">
      <Reveal className="max-w-3xl">
        <SectionLabel tone="light">Worldwide Inspection Services</SectionLabel>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight tracking-tight text-white">
          Inspection calls attended till date, country wise
        </h2>
      </Reveal>

      <div
        className="mt-14 grid grid-cols-2 gap-px bg-white/10 sm:grid-cols-3 lg:grid-cols-5"
        data-testid="country-grid"
      >
        {COUNTRIES.map((c, i) => (
          <Reveal key={c.name} delay={Math.min(i, 10) * 0.03}>
            <div className="group h-full bg-[#0A192F] px-6 py-7 hover:bg-[#0E2440] transition-colors duration-300">
              <div className="font-display text-2xl font-extrabold text-[#D4AF37]">
                {c.calls}
              </div>
              <div className="mt-1.5 text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-400 group-hover:text-[#22D3EE] transition-colors duration-300">
                {c.name}
              </div>
            </div>
          </Reveal>
        ))}
        <Reveal delay={0.3}>
          <div className="h-full bg-[#0A192F] px-6 py-7">
            <div className="font-display text-2xl font-extrabold text-white/40">+</div>
            <div className="mt-1.5 text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">
              Other countries
            </div>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.1}>
        <div className="mt-20 border-t border-white/10 pt-12">
          <p className="font-display text-xs font-bold uppercase tracking-[0.24em] text-[#22D3EE]">
            Equipment inspected till date in worldwide locations
          </p>
          <div className="mt-7 flex flex-wrap gap-2.5" data-testid="equipment-list">
            {EQUIPMENT.map((e) => (
              <span
                key={e}
                className="rounded-full border border-white/15 px-4 py-2 text-xs font-medium text-slate-300 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors duration-300"
              >
                {e}
              </span>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
